<script setup lang="ts">
import { onMounted } from 'vue';
import DashboardDialog from './components/dashboard/DashboardDialog.vue';
import InfoPanelControls from './components/Info-panel/InfoPanelControls.vue';
import LeafletMap from './components/map-panel/LeafletMap.vue';
import { useAppStore } from './stores/appStore.ts';

const appStore = useAppStore()

onMounted(() => {
  appStore.bootstrap()
})

</script>
<template>
  <v-app>
    <LeafletMap />
    <InfoPanelControls />
    <DashboardDialog />
  </v-app>
</template>
<style lang="css">
@import 'https://cdn.jsdelivr.net/npm/vuetify/dist/vuetify.min.css';
@import url('https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css');
</style>